import Head from 'next/head'
import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Link from 'next/link'
import swal from '@sweetalert/with-react';
import PubSub from 'pubsub-js'
import slugify from 'react-slugify';



import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from '@material-ui/core/DialogContentText';

import { logEvent } from '../../utils/analytics';
import Service from "../../services/service";
import Image from "../../components/image";
import PerfilHeader from "../../components/perfilHeader";
import PerfilSolicitacoes from "../../components/perfilSolicitacoes";
import PerfilComentarios from "../../components/perfilComentarios";
import InstagramListFeedAPI from "../../components/instagramListFeedAPI";
import MyRecommendationUsers from "../../components/myRecommendationUsers";
import Meta from "../../components/meta";
import ModalAvaliacaoColaborador from "../../components/modalAvaliacaoColaborador";
import PhoneButton from "../../components/phoneButton";
import ResponsiveModal from '../../components/responsiveModal.js'


import { connect } from 'react-redux';
import actions from '../../redux/actions';

import ShareIcon from '@material-ui/icons/Share';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import CommentIcon from '@material-ui/icons/Comment';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbDownIcon from '@material-ui/icons/ThumbDown';
import StarHalfIcon from '@material-ui/icons/StarHalf';

import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const Index = (props) => {

  const { isFallback, query, reload, push } = useRouter();

  const [model, setModel] = useState(props?.profile);
  const [telefones, setTelefones] = useState(null);
  const [submited, setSubmited] = useState(false);

  const [sendingRecomendation, setSendingRecomendation] = useState(false);

  const [open, setModal] = useState(false);
  const [form, setForm] = useState({
    mensagem: ``,
    recipient: model?._id,
    feeback: 'POSITIVO'
  });

  // const [chunck,setChunk] = useState([])


  // useEffect(() => {

  //   const source = new EventSource(`${Service.api}/sse`);

  //   source.onmessage = (event) => {
  //     console.log(event);
  //   };

  //   source.addEventListener("customEvent", (e) => {
  //     console.log("customEvent", e.data);
  //   });

  //   source.addEventListener("notice", (e) => {
  //     console.log(e.data);
  //   });

  //   source.addEventListener("update", (e) => {
  //     console.log(e.data);
  //   });

  //   source.addEventListener('message', (event) => {
  //     const data = JSON.parse(event.data);
  //     console.log('Nova mensagem recebida via SSE:', data);
  //     // Faça algo com a mensagem recebida aqui.
  //   });

  //   source.onopen = () => {
  //     console.log('Conexão SSE estabelecida.');
  //   };

  //   source.onerror =  (event) => {
  //     console.error('Error:', event);
  //   };


  // }, [])


  /* comentarios */
  const [sendingComentarios, setSendingComentarios] = useState(false);
  const [openComentar, setModalComentar] = useState(false);  
  const [formComent, setFormComent] = useState({
    message: ``,
    hint: ``
  });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  /* comentarios */
  const openModalComent = (hint) => {
    setFormComent({
      message: '',
      hint: hint._id
    });

    setModalComentar(true);
  }

  const handleChangeFormComent = (event) => {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    setFormComent({
      ...formComent,
      [name]: value
    })
  }

  /* aqui comenta sobre a dica */
  const handleSubmitComentario = async (event) => {

    event.preventDefault();

    const id = model._id; // id da diarista
    const isAuthenticated = props.isAuthenticated;

    logEvent('PERFIL', `LIKE SOBRE A DICA DA DIARISTA ${model.nome}`);

    if(!isAuthenticated){
      PubSub.publish('openModal', model);
      return false
    }

    setSendingComentarios(true);

    Service.saveComentarioHint(formComent).then(resp => {

      setSendingComentarios(false);
      setModalComentar(false);

      swal({content: <div><p className="text-center">Que shooow {props?.user?.nome}, seu comentário foi aceito e será compartilhado com todos os contratantes da plataforma ❤</p><h3 className="barlow fw-bold">Na Odete você pode MUITO mais!</h3></div>, icon: 'success'}).then(() => {
        reload();
      });

    }).catch(e => {
      alert('Ixi...Ocorreu um erro');
    });
  }

  const handleChange = (event) => {

    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    setForm({
      ...form,
      [name]: value
    })
  }

  /* aqui faz a recomendacao da diarista */
  const handleSubmit = async (event) => {

    event.preventDefault();

    const id = model._id; // id da diarista
    const isAuthenticated = props.isAuthenticated;

    // setSendingRecomendation(true);

    // swal({content: <div><p className="text-center">Obrigado {props?.user?.nome}, sua recomendação foi aceita e será compartilhada com todos os contratantes da plataforma ❤</p><h3 className="barlow fw-bold">Na Odete você pode MUITO mais!</h3></div>, icon: 'success'}).then(async () => {
    //   let profile = await Service.getColaborador(query.id);
    //   setModel(profile);
    //   setSendingRecomendation(false);
    //   setModal(false);
    //   push("#recomendacoes")
    // });

    // return false;

    logEvent('PERFIL', `RECOMENDACAO SOBRE A DIARISTA ${model.nome}`);

      if(!isAuthenticated){
        PubSub.publish('openModal', model);
        return false
      }

      if(props?.user?._id === id){
        swal('', 'Ops, você não pode recomendar seu próprio perfil :)', 'error');
        return false;
      }

    setSendingRecomendation(true);

    Service.saveComentario(form).then(resp => {

      if(!resp.success){
        swal('', `${resp.message}`, 'error');
      }else {

        swal({content: <div><p className="text-center">Obrigado {props?.user?.nome}, sua recomendação foi aceita e será compartilhada com todos os contratantes da plataforma ❤</p><h3 className="barlow fw-bold">Na Odete você pode MUITO mais!</h3></div>, icon: 'success'}).then(async () => {
          let profile = await Service.getColaborador(query.id);
          setModel(profile);
        });

      }
    }).catch(e => {
      alert('Ixi...Ocorreu um erro');
    }).finally(() => {
      setSendingRecomendation(false);
      setModal(false);
      push("#recomendacoes")
    });
  }

  useEffect(()=> {
    if(query.action != ''){
      
      if(query.action === 'avaliar'){
        openModalAvaliacao(props.profile)
      }

      if(query.action === 'recomendar'){
        setModal(true)
      }
    }
  }, [])

  const openModalAvaliacao = (model) => {
    model.callback = async () => {
      let profile = await Service.getColaborador(query.id);
      setModel(profile);
      push("#atendimentos")
      //location.href = url;
      //reload()
    }
    PubSub.publish('openModalAvaliacaoColaborador', model)
  }

  let profile = props.profile;
  let url = `https://odete.com.br/diarista/${profile?._id}`;
  let description = `Diarista ${profile?.nome} em ${profile?.cidade}/${profile?.uf} - na Odete desde ${Service.formatDate(profile?.createdAt, 'dd/MM/yyyy HH:mm:ss')}`;
  let keywords = `diarista ${profile?.nome} ${profile?.sobrenome} está em ${profile?.cidade} - ${profile?.uf}, odete diaristas, contrate diaristas, site para diaristas, diaristas no brasil, app para diaristas`;
  let image = `https://api.odete.com.br/resizeImage?url=${Service.parseURLImage(profile)}&width=200`;
  let title = Service.mostrar70Caracteres(`Diarista ${profile?.nome} em ${profile?.cidade} - na Odete desde ${Service.formatDate(profile?.createdAt, 'dd/MM/yyyy HH:mm:ss')}`);
  let atendimentos = profile?.solicitacoes?.filter(item => item.matchColaborador && item.matchContratante)

  return (
      <main id="topo">

        <div className="duration-300 ease-out transition-all opacity-0 d-block p-2 border-bottom position-sticky border-1 z-3 start-0 end-0 bg-light animated-button" id="telefone-fixo" style={{top: `${Service.stickyTopConfig}px`}}>
          <PhoneButton model={profile} className="btn-block btn-lg w-100" disabledPublishOferta={true} />
        </div>

        <Head>

          <title key="title">{title}</title>

          <meta property="og:title" content={title} />
          <meta property="og:site_name" content={title} />

          <link rel="canonical" href={url} />
          <meta property="og:url" content={url}/>

          <meta property="og:image" content={image} />
          <meta property="og:image:secure_url" content={image} />

          <link rel="preload" as="image" href={image} fetchpriority="high" />



          <meta property="og:image:alt" content={description} />
          <meta property="og:description" content={description}/>
          <meta name="description" content={description} />
          <meta name="keywords" content={keywords}/>

          <Meta disabledImage={true} />

          <script type="application/ld+json" dangerouslySetInnerHTML={ { __html: `{
              "@context": "http://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                  {
                      "@type": "ListItem",
                      "position": 1,
                      "item": {
                          "@id": "https://odete.com.br",
                          "name": "Odete"
                      }
                  },
                  {
                      "@type": "ListItem",
                      "position": 2,
                      "item": {
                          "@id": "https://odete.com.br/diaristas",
                          "name": "Diaristas"
                      }
                  },
                  {
                      "@type": "ListItem",
                      "position": 3,
                      "item": {
                          "@id": "https://odete.com.br/diaristas/${profile?.uf}",
                          "name": "Diaristas em ${profile?.uf}"
                      }
                  },
                  {
                      "@type": "ListItem",
                      "position": 4,
                      "item": {
                          "@id": "/https://odete.com.br/diaristas/${profile?.uf}/${slugify(profile?.cidade)}",
                          "name": "Diaristas em ${profile?.cidade}"
                      }
                  },
                  {
                      "@type": "ListItem",
                      "position": 5,
                      "item": {
                          "@id": "${url}",
                          "name": "Diarista ${profile.nome} em ${profile?.cidade}/${profile?.uf}"
                      }
                  }
              ]
          }`}} />

          <script type="application/ld+json" dangerouslySetInnerHTML={ { __html: `
          {
            "@context": "https://schema.org",
            "@type": "Product",
            "name": "${profile.nome} - Serviço de Diarista de Limpeza Profissional em ${profile?.cidade}",
            "description": "Contrate a diarista ${profile.nome} para manter a sua casa impecável e organizada. Na Odete as profissionais são qualificados e garantem uma limpeza detalhada e eficiente, adaptada às suas necessidades.",
            "image": "${Service.parseURLImage(profile)}",
            "offers": {
              "@type": "Offer",
              "url": "https://odete.com.br/diarista/${profile._id}",
              "priceCurrency": "BRL",
              "price": ${profile.valor},
              "priceValidUntil": "2023-12-31",
              "availability": "https://schema.org/InStock"
            },
            "aggregateRating": {
              "@type": "AggregateRating",
              "ratingValue": "5",
              "reviewCount": 120
            },
            "review": [
                {
                  "@type": "Review",
                  "author": {
                    "@type": "Person",
                    "name": "Carlos Silva"
                  },
                  "datePublished": "2024-03-01",
                  "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "bestRating": "5"
                  },
                  "reviewBody": "Ótima, muito confiável!"
                },
                {
                  "@type": "Review",
                  "author": {
                    "@type": "Person",
                    "name": "Ana Souza"
                  },
                  "datePublished": "2024-02-15",
                  "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "4",
                    "bestRating": "5"
                  },
                  "reviewBody": "Gostei bastante, mas poderia ter mais dias na agenda."
                }
              ]
          }

          `}} />

          <script type="application/ld+json" dangerouslySetInnerHTML={ { __html: `{
              "@context": "http://schema.org",
              "@type": "Article",
              "name": "Diarista ${profile.nome} em ${profile?.cidade}",
              "author": {
                  "@type": "Person",
                  "name": "Odete",
                  "url": "https://odete.com.br/assets/images/logo-odete-header.webp"
              },
              "keywords": "${keywords}",
              "description": "${description}",
              "datePublished": "${profile.createdAt}",
              "publisher": {
                "@type": "Organization",
                "name": "Odete",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://odete.com.br/assets/images/logo-odete-header.webp"
                }
              },
              "image": {
                "@type": "ImageObject",
                "url": "${image}",
                "width": 160,
                "height": 160
              },
              "headline": "Diarista ${profile.nome} em ${profile?.cidade}",
              "articleBody": "${description}"
          }`}} />

          <script type="application/ld+json" dangerouslySetInnerHTML={ { __html: `{
            "@context": "https://schema.org/",
            "@type": "Person",
            "name": "Diarista ${profile.nome}",
            "url": "${url}",
            "image": {
              "@type": "ImageObject",
              "url": "${image}",
              "width": 160,
              "height": 160
            },
            "description": "${description}",
            "jobTitle": "Diarista",
            "worksFor": {
                "@type": "Organization",
                "name": "Odete"
            }
          }`}} />

          <script type="application/ld+json" dangerouslySetInnerHTML={ { __html: `{
              "@context": "http://www.schema.org",
              "@type": "ProfessionalService",
              "name": "Diarista ${profile?.nome}",
              "description": "${description}",
              "url": "${url}",
              "image": {
                "@type": "ImageObject",
                "url": "${image}",
                "width": 160,
                "height": 160
              },
              "priceRange": "${profile?.valor}",
              "aggregateRating": {
                  "@type": "AggregateRating",
                  "bestRating": 5,
                  "worstRating": 0,
                  "ratingValue": 5,
                  "reviewCount": 2,
                  "ratingCount": 2
              },
              "review": [
                  {
                      "@type": "Review",
                      "author": {
                          "name": "Diego B.",
                          "@type": "Person"
                      },
                      "description": "Excelente profissional!",
                      "reviewRating": {
                          "@type": "Rating",
                          "bestRating": 5,
                          "ratingValue": 5,
                          "worstRating": 0
                      }
                  }
              ],
              "brand": {
                "@type": "Brand",
                "name": "Odete",
                "logo": "https://odete.com.br/assets/images/logo-odete-header.webp"
              },
              "address": {
                 "@type": "PostalAddress",
                 "addressLocality": "${profile?.cidade}",
                 "addressRegion": "${profile?.uf}",
                 "addressCountry": "Brasil"
              }
          }`}} />

        </Head>

        <ResponsiveModal open={open} onClose={() => setModal(false)}>
            <form onSubmit={handleSubmit} name="form" className="d-flex flex-column h-100 overflow-hidden">
              <DialogContent dividers={true}>
                <DialogContentText>
                  Obrigado, a sua recomendação vai servir para que eu tenha novas oportunidades!
                </DialogContentText>
                  <fieldset className="" disabled={sendingRecomendation}>
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="mensagem">Recomendar {model?.nome}:</label>
                      <textarea name="mensagem" autoFocus required={true} placeholder="Digite aqui sua mensagem" id="mensagem" className="form-control" rows="5" value={form.mensagem} onChange={handleChange} />
                    </div>
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="tipo">Feedback:</label>
                      <div className="d-flex gap-2" role="group">
                        <label className="btn w-100" htmlFor="negativo">
                          <div className="d-flex align-items-center gap-2 justify-content-center">
                            <input onChange={handleChange} type="radio" className="" name="feedback" id="negativo" autoComplete="off" required={true} value="NEGATIVO" />
                            <ThumbDownIcon />
                          </div>
                          <span className="d-block">Negativo</span>
                        </label>

                        <label className="btn w-100" htmlFor="positivo">
                          <div className="d-flex align-items-center gap-2 justify-content-center">
                            <input onChange={handleChange} type="radio" className="" name="feedback" id="positivo" autoComplete="off" required={true} value="POSITIVO" />
                            <ThumbUpIcon />
                          </div>
                          <span className="d-block">Positivo</span>
                        </label>

                      </div>
                    </div>
                  </fieldset>
              </DialogContent>
              <DialogActions>
                <button type="button" onClick={() => setModal(false)} className="w-100 btn btn-outline-secondary btn-lg btn-block text-uppercase">cancelar</button>

                <button type="submit" className="w-100 btn btn-primary btn-block btn-lg text-uppercase">
                  {sendingRecomendation ? 'enviando...' : 'enviar'}
                </button>
              </DialogActions>          
            </form>
        </ResponsiveModal>

        <ResponsiveModal open={openComentar} onClose={() => setModalComentar(false)}>
            <form onSubmit={handleSubmitComentario} name="form" className="d-flex flex-column h-100">
              <DialogTitle>
                <div className="d-flex align-items-center justify-content-between">
                  <div>O que achou desta dica?</div>
                  <IconButton aria-label="close" onClick={() => setModalComentar(false)}>
                    <CloseIcon titleAccess="fechar modal" />
                  </IconButton>
                </div>
              </DialogTitle>
              <DialogContent dividers={true}>
                <DialogContentText>
                  Obrigado, o seu comentário vai dar mais credibilidade para esta essa dica!
                </DialogContentText>
                  <fieldset className="" disabled={sendingComentarios}>
                    <div className="form-group">
                      <label className="form-label" htmlFor="messagee">Comentar:</label>
                      <textarea name="message" required={true} placeholder="Digite aqui sua mensagem" id="message" className="form-control" rows="5" value={formComent.message} onChange={handleChangeFormComent} />
                    </div>
                  </fieldset>
              </DialogContent>
              <DialogActions>
                <button type="button" onClick={() => setModalComentar(false)} className="w-100 btn btn-outline-secondary btn-lg btn-block text-uppercase">cancelar</button>
                <button type="submit" className="w-100 btn btn-primary btn-block btn-lg text-uppercase">
                  {sendingComentarios ? 'enviando...' : 'enviar'}
                </button>
              </DialogActions>          
            </form>
        </ResponsiveModal>

        <div className="p-3 p-sm-5 mb-4 jumbotron bg-light jumbotron-diarista" id="conteudo">
          <PerfilHeader profile={profile} />
        </div>

        <aside>
          <div className="container mb-4">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link prefetch={false} href="/">Home</Link></li>
                <li className="breadcrumb-item"><Link prefetch={false} href="/diaristas">Diaristas</Link></li>
                <li className="breadcrumb-item"><Link prefetch={false} href={`/diaristas/${profile?.uf?.toLowerCase()}`}>{profile?.uf}</Link></li>
                <li className="breadcrumb-item"><Link prefetch={false} href={`/diaristas/${profile?.uf?.toLowerCase()}/${slugify(profile?.cidade)}`}>{profile?.cidade}</Link></li>
                <li className="breadcrumb-item active" aria-current="page">{profile?.nome}</li>
              </ol>
            </nav>
            <div className="row">
              <div className="col-12 mb-4 px-4">
                <h3 className="display-4">sobre mim...</h3>
                <p className="text-muted">{profile?.historico}</p>
              </div>

              {/* meus atendimentos */}
              {profile?.solicitacoes &&  profile?.solicitacoes?.length > 0 && <PerfilSolicitacoes profile={profile} />}

              {/* minhas dicas */}
              {
                profile?.hints && profile?.hints.length > 0 &&
                <div className="col-12 mb-5">
                  <h3 className="display-4 mb-4">minhas dicas...</h3>
                  {(!profile?.hints || profile?.hints?.length === 0) && <p className="text-danger">Nenhuma dica cadastrada ainda!</p>}
                  {
                    profile?.hints && profile?.hints.map(item => {
                    let time = new Date(item.createdAt).toISOString();
                    return (

                        <details key={item._id} className="mb-1">
                          <summary className="btn border border-dark w-100 text-start barlow fw-bold">{item.title.toUpperCase()}</summary>
                          <p className="p-3 text-break-spaces m-0">{item.description}</p>
                          {
                              item?.comentarios && item?.comentarios?.length > 0 && <div>
                                <hr />
                                <p className="mb-4 lead">Comentários</p>
                                {
                                  item?.comentarios && item?.comentarios.map(item => (

                                  <div key={item._id} className="mb-4">
                                    <div className="d-flex align-items-start">
                                      <Image src={Service.parseURLImage(item.comentarista)} width="60" height="60" classNameFigure="me-2" alt={item.comentarista.nome} className="rounded-circle img-thumbnail me-2 image-perfil" /> 
                                      <div className="flex-fill">
                                        <p className="lh font-weight-bold m-0">{item.comentarista.nome}</p>
                                        <small>
                                          {item.createdAt}
                                        </small>
                                        <p className="text-muted text-break-spaces">{item.message}</p>
                                      </div>
                                    </div>
                                  </div>
                                    ))
                                }
                            </div>
                          }
                          <div className="mb-3 d-flex gap-3 justify-content-end">
                            <a href={`https://api.odete.com.br/shareHint/${item._id}`} target="_blank" className="btn btn-outline-primary rounded-pill"><ShareIcon /> Compartilhar</a>
                            <button className="btn btn-outline-primary rounded-pill" onClick={() => openModalComent(item)}><CommentIcon /> Comentar</button>
                          </div>
                        </details>
                      )
                    })
                  }
                </div>
              }

              {/* minhas recomendacoes */}
              {profile?.comentarios && profile?.comentarios?.length > 0 && <PerfilComentarios profile={profile} />}

              {profile?._id && <MyRecommendationUsers id={profile?._id} />}

              {(!Service.verificaPagamento(profile) && profile?.instagram?.username) && <InstagramListFeedAPI id={profile?._id} username={profile?.instagram?.username} />}

              <div className="col-12 col-md-6 text-center mb-4">
                <ThumbUpIcon fontSize="large" titleAccess="Recomendar" className="d-block m-auto" />
                <strong>Conhece {profile?.nome}?</strong>
                <p>Gostaria de deixar uma mensagem de recomendação para que outras pessoas pudessem ter referências sobre seu serviço?</p>
                <button  type="button" className="btn px-4 rounded-pill btn-outline-primary" onClick={() => setModal(true)}>Claro, posso recomendar!</button>
              </div>

              <div className="col-12 col-md-6 text-center">
                <StarHalfIcon fontSize="large" titleAccess="Avaliar" className="d-block m-auto" />
                <strong>Chegou a contratar {profile?.nome}?</strong>
                <p>Que tal avaliar o serviço realizado? Isso vai servir para que outras pessoas confiem ainda mais na hora de realizar a contratação!</p>
                <button type="button" onClick={() => openModalAvaliacao(profile)} className="btn px-4 rounded-pill btn-outline-danger">
                  Claro, quero avaliar!
                </button>
              </div>
            </div>
          </div>
        </aside>

        <ModalAvaliacaoColaborador />
      </main>
  );
}

export const getServerSideProps = async ({ pathname, query, req, res }) => {

  //res.setHeader('Cache-Control', 's-maxage=1, stale-while-revalidate');

    const protocol = req.headers['x-forwarded-proto'] || 'http';

    // Host (domínio)
    const host = req.headers.host;

    // Caminho (path) da URL
    const path = req.url;

    // URL completa
    const url = `${protocol}://${host}${path}`;



  let profile = await Service.getColaborador(query.id);

  if(!profile || profile.success === false){
    return {
      redirect: {
        destination: '/',
        permanent: false,
      }
    }
  }


  return {
    props: {profile, url}
  };
}


// export const getStaticPaths = async () => {

//   // const _paths = await Service.getDiaristasId();
//   // const paths = _paths.map(item => ({
//   //   params: { id: item._id },
//   // }));

//   return {
//     fallback:true,
//     paths: []
//   };
// }

// export const getStaticProps = async ({ params }) => {

//   let profile = await Service.getColaborador(params.id);

//   return {
//     props: {
//       profile
//     },
//     revalidate: 1
//   };
// }


const mapStateToProps = (state) => ({
    isAuthenticated: !!state.authentication.token,
    token: state.authentication.token,
    user: state.authentication.user
  }
);

export default connect(mapStateToProps, actions)(Index);